/* eslint-disable no-use-before-define */

import React from "react";
import {
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import MenuButton from "../components/MenuButton";
import WebHeading from "../components/WebHeading";
import goTo from "../utils/goTo";
import { RepositColours, RepositStyles } from "../utils/styles";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { goHomeReceived, resetStore } from "../redux/actions/menu";
import Icon from "react-native-vector-icons/FontAwesome";
import { NavigationActions } from "react-navigation";

const Plus = <Icon name="plus" size={20} color={RepositColours.blue} />;
const Refresh = <Icon name="retweet" size={20} color={RepositColours.blue} />;
const Check = <Icon name="search" size={20} color={RepositColours.blue} />;
const ChevRight = (
  <Icon
    name="chevron-right"
    size={20}
    color="#CECED2"
    style={{ fontWeight: "300" }}
  />
);

const mapStateToProps = (state) => ({
  menu: state.menu,
  box: state.box,
  customer: state.customer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    menuActions: bindActionCreators({ goHomeReceived, resetStore }, dispatch),
  };
};

class Main extends React.Component {
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "Home",
  };

  componentDidMount() {
    if (Platform.OS !== "web") {
      navigator.geolocation.getCurrentPosition(
        (position) => {},
        (error) => {}
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (Platform !== "web") {
      if (!this.props.menu.goHome && nextProps.menu.goHome) {
        const resetAction = NavigationActions.reset({
          index: 0,
          actions: [NavigationActions.navigate({ routeName: "Main" })],
        });
        this.props.navigation.dispatch(resetAction);
        this.props.menuActions.goHomeReceived();
        setTimeout(this.props.menuActions.resetStore, 1000);
      }
    }
  }

  render() {
    return (
      <View style={{ flex: 1, backgroundColor: "white" }}>
        <WebHeading title="Home" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View
            style={{
              flexDirection: "column",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <View
              style={{
                marginTop: 50,
                borderBottomColor: "#E2E2E2",
                borderBottomWidth: 1,
              }}
            >
              <Text
                style={{
                  ...RepositStyles.welcomeText,
                  marginHorizontal: 20,
                  marginBottom: 20,
                }}
              >
                Please select{"\n"}one of the following
              </Text>
            </View>
            <TouchableOpacity
              style={styles.listItem}
              onPress={() => {
                goTo(this.props.navigation, "StartInstall");
              }}
            >
              <Text style={{ flex: 1, textAlign: "center" }}>{Plus}</Text>
              <Text style={{ ...styles.buttonText, flex: 5 }}>
                Set up a new Reposit Box
              </Text>
              <Text style={{ flex: 1, textAlign: "center" }}>{ChevRight}</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.listItem}
              onPress={() => {
                goTo(this.props.navigation, "SerialValidate");
              }}
            >
              <Text style={{ flex: 1, textAlign: "center" }}>{Check}</Text>
              <Text style={{ ...styles.buttonText, flex: 5 }}>
                Check an existing installation
              </Text>
              <Text style={{ flex: 1, textAlign: "center" }}>{ChevRight}</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.listItem}
              onPress={() => {
                goTo(this.props.navigation, "ReplaceInstall");
              }}
            >
              <Text style={{ flex: 1, textAlign: "center" }}>{Refresh}</Text>
              <Text style={{ ...styles.buttonText, flex: 5 }}>
                Replace an existing Reposit Box
              </Text>
              <Text style={{ flex: 1, textAlign: "center" }}>{ChevRight}</Text>
            </TouchableOpacity>
            <View style={{ flex: 2 }} />
            <View style={{ marginBottom: 20 }}></View>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  listItem: {
    maxWidth: 400,
    minWidth: 350,
    height: 110,
    borderBottomColor: "#E2E2E2",
    borderBottomWidth: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  heading: {
    borderBottomColor: "#E2E2E2",
    borderBottomWidth: 1,
    justifyContent: "center",
    backgroundColor: "#FAFAFA",
  },
  buttonText: {
    fontSize: 16,
    margin: 10,
    flex: 1,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/containers/Main.js